module.exports = __webpack_public_path__ + "static/media/Medica.8ad96f72.png";